import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { InvoiceService } from '../../../../Services/Invoice/invoice.service';

@Component({
  selector: 'app-product-category-wise-sale',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './product-category-wise-sale.component.html',
  styleUrl: './product-category-wise-sale.component.css'
})
export class ProductCategoryWiseSaleComponent implements OnInit {
  
  activeTab: 'all' | 'ready_piece' | 'ready_lot' | 'products' | 'assembly' = 'all';

  // Raw Data Buckets
  readyPieceSales: any[] = [];
  readyLotSales: any[] = [];
  productSales: any[] = [];
  assemblyLine: any[] = [];

  // Pagination Settings
  pageSize = 5;
  pages = { piece: 1, lot: 1, product: 1, assembly: 1 };

  // Stats / KPIs
  stats = [
    { label: 'Total Revenue', value: '₹ 0', icon: '💰', color: 'bg-green-100 text-green-600' },
    { label: 'Total Weight', value: '0g', icon: '⚖️', color: 'bg-yellow-100 text-yellow-600' },
    { label: 'Total Items', value: '0', icon: '📦', color: 'bg-blue-100 text-blue-600' },
  ];

  constructor(private invoiceService: InvoiceService) {}

  ngOnInit() {
    this.invoiceService.getInvoices().subscribe((res: any) => {
      const invoices = Array.isArray(res) ? res : (res.data || []);
      this.processInvoices(invoices);
    });
  }

  processInvoices(invoices: any[]) {
    let totalRev = 0;
    let totalWt = 0;
    let itemCount = 0;

    invoices.forEach(inv => {
      inv.items.forEach((item: any) => {
        const amt = parseFloat(item.stout_final_amount || 0);
        const wt = parseFloat(item.stout_total_wt || 0);
        const type = item.category?.Type;
        const subType = item.category?.SubType;

        totalRev += amt;
        totalWt += wt;
        itemCount++;

        const dataItem = {
          name: item.stout_item_name || item.category?.name,
          barcode: item.stout_barcode,
          weight: wt + 'g',
          amount: '₹ ' + amt.toLocaleString(),
          purity: item.stout_purity || item.stout_metal_type,
          status: item.stout_status || 'Invoiced'
        };

        if (type === 'Master' && subType === 'piece') this.readyPieceSales.push(dataItem);
        else if (type === 'Master' && subType === 'lot') this.readyLotSales.push(dataItem);
        else if (type === 'Product') this.productSales.push(dataItem);
        else if (type === 'Assembly') this.assemblyLine.push({ ...dataItem, color: this.getRandomColor() });
      });
    });

    this.stats[0].value = '₹ ' + (totalRev / 100000).toFixed(2) + ' L';
    this.stats[1].value = (totalWt / 1000).toFixed(2) + ' Kg';
    this.stats[2].value = itemCount.toString();
  }

  // Pagination Helper
  getPaginatedData(data: any[], page: number) {
    const start = (page - 1) * this.pageSize;
    return data.slice(start, start + this.pageSize);
  }

  getTotalPages(data: any[]) {
    return Math.ceil(data.length / this.pageSize) || 1;
  }

  changePage(type: 'piece' | 'lot' | 'product' | 'assembly', step: number) {
    this.pages[type] += step;
  }

  getRandomColor() {
    const colors = ['bg-orange-400', 'bg-blue-400', 'bg-purple-400', 'bg-green-400'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  setTab(tab: any) { this.activeTab = tab; }

  get showPiece() { return this.activeTab === 'all' || this.activeTab === 'ready_piece'; }
  get showLot() { return this.activeTab === 'all' || this.activeTab === 'ready_lot'; }
  get showProduct() { return this.activeTab === 'all' || this.activeTab === 'products'; }
  get showAssembly() { return this.activeTab === 'all' || this.activeTab === 'assembly'; }
}